import * as React from "react";
import {connect} from "react-redux";
import {OutdatedWarningPresentation} from "../common/ui/outdatedwarning/OutdatedWarning";
import {actions} from "./actions";
import {selectors} from "./selectors";

const mapStateToProps = (state) => {
  return {
    numberOfNewDataItems: selectors.getNumberOfNewDataItemsOnServer(state),
    numberOfRemovedDataItems: selectors.getNumberOfRemovedDataItemsOnServer(state),
    numberOfNewFolders: selectors.getNumberOfNewFoldersOnServer(state),
    numberOfRemovedFolders: selectors.getNumberOfRemovedFoldersOnServer(state),
    messageType: "data",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    refreshLinkClicked: () => {
      dispatch(actions.clearData());
      dispatch(actions.loadDataTypes());
      dispatch(actions.loadFolders())
    },
  };
};

export const DataOutdatedWarning = connect(mapStateToProps, mapDispatchToProps)(OutdatedWarningPresentation);
